import React from "react"

const Loading = () => {
    return (
        <div className="bg-white fixed z-99999 top-0 left-0 w-screen h-screen" />
    )
}

export default Loading
